import {clamp,smooth,sampleTimeline,tennisBall,runnerPose} from './game-story-timeline.js';
const controllers=new WeakMap(), reduced=matchMedia('(prefers-reduced-motion: reduce)'),mobile=matchMedia('(max-width:760px)');
function mount(root){
  if(controllers.has(root))return;
  const story=root.querySelector('[data-game-story]');if(!story)return;
  const panels=[...story.querySelectorAll('[data-play-panel]')],tabs=[...story.querySelectorAll('[data-play-tab]')];
  if(!panels.length)return;
  const surface=story.closest('[data-home-section]'),pin=story.querySelector('[data-play-pin]'),outro=story.querySelector('[data-play-outro]'),nav=story.querySelector('.play-nav');
  const weights=panels.map(el=>Number(el.dataset.scrollWeight)||1.1),total=weights.reduce((a,b)=>a+b,0)+.8;
  const abort=new AbortController(),{signal}=abort;
  const on=(el,event,fn,options={})=>el?.addEventListener(event,fn,{...options,signal});
  let frame=0,visible=false,manual=null,lastSample=null,selected=-1;
  const motion=()=>!reduced.matches&&surface.dataset.motion!=='false';
  const tennisParts=new WeakMap();
  panels.filter(el=>el.dataset.gameKind==='tennis').forEach(panel=>tennisParts.set(panel,Object.fromEntries(['arm','ball','trail','shadow','impact'].map(part=>[part,panel.querySelector(`[data-tennis-${part}]`)]))));
  const runnerParts=new WeakMap();
  panels.filter(el=>el.dataset.gameKind==='runner').forEach(panel=>runnerParts.set(panel,Object.fromEntries(['body','torso','leg-back','leg-front','shoe-back','shoe-front','arm-back','arm-front','shadow','hurdle','track','hills','takeoff-dust','landing-dust'].map(part=>[part,panel.querySelector(`[data-runner-${part}]`)]))));
  function select(index){
    if(index===selected)return;selected=index;
    tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;});
    panels.forEach((panel,i)=>{panel.setAttribute('aria-hidden',String(i!==index));panel.inert=i!==index;});
    story.dataset.gameIndex=String(index);story.style.setProperty('--play-color',panels[index].dataset.background);
  }
  function art(panel,action){
    panel.style.setProperty('--game-action',String(action));
    if(panel.dataset.gameKind==='tennis'){
      const {arm,ball,trail,shadow,impact}=tennisParts.get(panel);
      const point=tennisBall(action),previous=tennisBall(Math.max(0,action-.07));
      arm.setAttribute('transform',`rotate(${-48+105*smooth(action/.72)} 915 571)`);
      ball.setAttribute('transform',`translate(${point.x} ${point.y})`);
      shadow.setAttribute('cx',String(point.x));shadow.setAttribute('cy',String(450+(point.y-230)*.65));
      trail.setAttribute('d',`M${previous.x} ${previous.y}Q${(previous.x+point.x)/2} ${(previous.y+point.y)/2} ${point.x} ${point.y}`);
      impact.setAttribute('opacity',String(Math.max(0,1-Math.abs(action-.52)/.09)));
    }else if(panel.dataset.gameKind==='runner'){
      const parts=runnerParts.get(panel),pose=runnerPose(action);
      const limb=(hip,knee,foot)=>`M${hip} ${knee.x} ${knee.y} ${foot.x} ${foot.y}`;
      parts.body.setAttribute('transform',`translate(865 ${740+pose.y})`);
      parts.torso.setAttribute('transform',`rotate(${pose.lean} 0 -108)`);
      parts['leg-back'].setAttribute('d',limb('-9 -108',pose.backKnee,pose.backFoot));
      parts['leg-front'].setAttribute('d',limb('8 -108',pose.frontKnee,pose.frontFoot));
      parts['shoe-back'].setAttribute('transform',`translate(${pose.backFoot.x} ${pose.backFoot.y}) rotate(${-12*pose.tuck})`);
      parts['shoe-front'].setAttribute('transform',`translate(${pose.frontFoot.x} ${pose.frontFoot.y}) rotate(${-18*pose.tuck})`);
      parts['arm-back'].setAttribute('transform',`rotate(${pose.backArm} -8 -181)`);
      parts['arm-front'].setAttribute('transform',`rotate(${pose.frontArm} 11 -179)`);
      parts.shadow.setAttribute('rx',String(65*pose.shadowScale));parts.shadow.setAttribute('opacity',String(pose.shadowOpacity));
      parts.hurdle.setAttribute('transform',`translate(${pose.hurdleX} 0)`);
      parts.track.setAttribute('transform',`translate(${-pose.ground} 0)`);
      parts.hills.setAttribute('transform',`translate(${-pose.ground*.1} 0)`);
      parts['takeoff-dust'].setAttribute('transform',`translate(${860-(pose.ground-650*.29)} 742)`);parts['takeoff-dust'].setAttribute('opacity',String(pose.takeoffDust));
      parts['landing-dust'].setAttribute('transform',`translate(${865-(pose.ground-650*.82)} 742) scale(${1+pose.landingSpread*.75} 1)`);parts['landing-dust'].setAttribute('opacity',String(pose.landingDust));
    }
    else if(panel.dataset.gameKind==='mole'){
      panel.style.setProperty('--mole-lift',`${(1-smooth(action/.3)+smooth((action-.69)/.15))*180}px`);
      const strike=smooth((action-.35)/.3);
      panel.style.setProperty('--hammer-turn',`${-30+20*strike}deg`);
      panel.style.setProperty('--hammer-x',`${-200*strike}px`);panel.style.setProperty('--hammer-y',`${150*strike}px`);
      panel.style.setProperty('--hit-opacity',String(Math.max(0,1-Math.abs(action-.65)/.12)));
    }else{
      const cut=smooth((action-.48)/.2);
      panel.style.setProperty('--candy-lift',`${(1-smooth(action/.36))*230}px`);
      panel.style.setProperty('--candy-cut',String(cut));
    }
  }
  function staticView(){
    panels.forEach((panel,index)=>{
      panel.hidden=false;panel.inert=false;panel.removeAttribute('aria-hidden');panel.style.removeProperty('opacity');panel.style.removeProperty('visibility');
      panel.style.setProperty('--open','1');panel.style.setProperty('--panel-y','0px');panel.style.setProperty('--panel-scale','1');art(panel,panel.dataset.gameKind==='runner'?.55:index===0 ? .3 : .4);
    });
    outro.removeAttribute('aria-hidden');outro.inert=false;nav.inert=false;story.classList.remove('is-outro');
  }
  function draw(){
    frame=0;if(signal.aborted||!motion()||!visible)return;
    const rect=story.getBoundingClientRect(),view=pin.getBoundingClientRect().height;
    const sample=sampleTimeline(clamp(-rect.top/Math.max(1,rect.height-view)),weights);lastSample=sample;
    if(manual&&manual.segment!==sample.index)manual=null;
    const index=manual?manual.index:Math.min(panels.length-1,sample.index);
    const phase=manual?.index===index? .26+.72*clamp((sample.time-manual.start)/Math.max(.18,sample.end-manual.start)):sample.phase;
    select(index);
    const open=smooth((phase-.04)/.24),action=smooth((phase-.31)/.52);
    const fade=sample.index>=panels.length?1-smooth(sample.outro/.35):1-smooth((phase-.94)/.06);
    const incoming=sample.index===0||manual?1:smooth(phase/.055);
    panels.forEach((panel,i)=>{
      const active=i===index;panel.hidden=false;panel.style.visibility=active?'visible':'hidden';panel.style.opacity=String(active?fade*incoming:0);
      if(!active)return;
      panel.style.setProperty('--open',String(open));panel.style.setProperty('--panel-y',`${-smooth((phase-.89)/.11)*25}px`);panel.style.setProperty('--panel-scale',String(1-smooth((phase-.89)/.11)*.025));art(panel,action);
    });
    const entry=clamp((innerHeight-rect.top)/innerHeight);
    story.style.setProperty('--play-entry',String(entry));
    story.style.setProperty('--play-intro',String(sample.index===0&&!manual?1-smooth(phase/.13):0));
    story.style.setProperty('--play-outro',String(smooth(sample.outro/.4)));
    const exit=smooth((sample.outro-.65)/.35);
    outro.style.backgroundColor=`rgb(${237+13*exit} ${229+19*exit} ${247-6*exit})`;
    story.classList.toggle('is-outro',sample.index>=panels.length);
    nav.inert=sample.index>=panels.length;
    outro.setAttribute('aria-hidden',String(sample.index<panels.length));outro.inert=sample.index<panels.length;
  }
  const schedule=()=>{if(!frame&&!document.hidden)frame=requestAnimationFrame(draw);};
  function sync(){
    manual=null;story.classList.toggle('game-story-ready',motion());
    surface.classList.toggle('game-section-ready',motion());
    story.style.setProperty('--game-runway',String(total*(mobile.matches ? .72 : 1)));
    panels.forEach(panel=>{const svg=panel.querySelector('.play-art');if(svg)svg.setAttribute('viewBox',mobile.matches?(panel.dataset.gameKind==='tennis'?'400 20 1000 1100':panel.dataset.gameKind==='runner'?'595 -120 540 1120':'220 0 1000 1000'):'0 0 1440 900');});
    if(!motion())staticView();else{selected=-1;schedule();}
  }
  function choose(index){
    if(!motion()){panels[index].scrollIntoView({block:'center',behavior:'instant'});return;}
    const sample=lastSample;if(!sample||sample.index>=panels.length)return;
    manual={index,segment:sample.index,start:sample.time};schedule();
  }
  tabs.forEach((tab,index)=>{
    tab.setAttribute('aria-controls',panels[index].id);panels[index].setAttribute('aria-labelledby',tab.id);
    on(tab,'click',()=>choose(index));
    on(tab,'keydown',event=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;event.preventDefault();
      const next=event.key==='Home'?0:event.key==='End'?tabs.length-1:(index+(event.key==='ArrowRight'?1:-1)+tabs.length)%tabs.length;
      choose(next);tabs[next].focus({preventScroll:true});
    });
  });
  const observer=new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;if(visible)schedule();},{rootMargin:'150px 0px'});observer.observe(story);
  on(window,'scroll',schedule,{passive:true});on(window,'resize',schedule,{passive:true});on(document,'visibilitychange',schedule);on(reduced,'change',sync);on(mobile,'change',sync);
  on(root,'shopify:block:select',event=>{
    const index=panels.findIndex(panel=>panel===event.target||panel.contains(event.target)||panel.dataset.blockId===event.detail?.blockId);
    if(index<0)return;
    if(motion()){
      const rect=story.getBoundingClientRect(),before=weights.slice(0,index).reduce((a,b)=>a+b,0);
      window.scrollTo({top:scrollY+rect.top+(rect.height-pin.getBoundingClientRect().height)*(before+weights[index]*.5)/total,behavior:'instant'});
    }else choose(index);
  });
  controllers.set(root,()=>{abort.abort();observer.disconnect();cancelAnimationFrame(frame);story.classList.remove('game-story-ready');surface.classList.remove('game-section-ready');panels.forEach(panel=>{panel.inert=false;panel.removeAttribute('aria-hidden');panel.removeAttribute('style');});controllers.delete(root);});
  sync();
}
const scan=()=>document.querySelectorAll('.shopify-section').forEach(mount);
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',scan,{once:true});else scan();
document.addEventListener('shopify:section:load',event=>mount(event.target));
document.addEventListener('shopify:section:unload',event=>controllers.get(event.target)?.());
